import React from 'react';
import { connect } from 'dva';
import moment from 'moment'

import { framework_tool, component_tool, utils_tool } from '@/tool'
import { getDetailRecord, formatAuth } from '@/utils/commonUtils'
let { WizContainer, WizAvatarUpload, modelUtils, ossFileUtils } = framework_tool;
let { WizCard, WizSpin, WizForm, } = component_tool;
let { Session } = utils_tool;

import {columns} from "./config";

class CleExamDetail extends WizContainer {
  componentName = 'CleExamDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};

    if (history.location && history.location.pathname === '/cle/examManager/upd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('cleExamRecord', initialValue)
      } else {
        initialValue = Session.get('cleExamRecord') || {};
      }
    }
    this.initialValue = initialValue;

    this.state = {
      loading: false,
    }
  }

  _render() {
    let formProps = {
      ref: 'form',
      columns: columns(this),
      onSubmit: this._onSubmit.bind(this),
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      style: { width: '100%' }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={this.state.loading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }

  propsAndStateOnChange = {
    save: this._save.bind(this),
  }

  _save(nextProps, nextState) {
    let o = nextProps.save
    nextState.loading = false;

    if (o['success']) {
      wizNotice.success(o['msg'])
      this.jumpPage('replace', '/cle/examManager');
    } else {
      wizNotice.error(o['msg'])
    }
    return true;
  }


  _onSubmit(values) {
    let data = {
      ...values,
      startDate: moment(values.startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(values.endDate).format('YYYY-MM-DD HH:mm:ss'),
      img: values?.img[0]?.fileId,
      authCmd: formatAuth(values.authCmd),
    }

    this.setState({
      loading: true,
    })

    this.doAction({
      path: 'cleExam/save',
      payload: {
        key: 'save',
        apiParams: { ...data }
      }
    })
  }
}

const mapStateToProps = (state, ownProps) => {
  const { cleExam } = state;
  const save = modelUtils.getModelEntity(cleExam, 'save');
  return {
    save
  }
};

export default connect(mapStateToProps)(CleExamDetail);
